const SocialSecurityNumberFilter = angular
    .module("SocialSecurityNumberFilter", [])
    .filter("ssn", [ssnFilter]);

function ssnFilter() {
    return function (ssn) {
        var delimiter = "-";

        // Format a valid SSN as ###-##-####
        if (ssn && ssn.length === 9) {
            return ssn.substr(0, 3) + delimiter + ssn.substr(3, 2) + delimiter + ssn.substr(5, 4);
        }

        return ssn;
    };
}

export default SocialSecurityNumberFilter;
